import styled from "styled-components";
import { breakpoints } from "styles";

export const TryTrialBlockWrapper = styled.section`
  padding: 30px;
  position: relative;
  @media ${breakpoints.laptop} {
    padding: 40px 0 40px 0;

    &:after {
      content: "";
      position: absolute;
      bottom: -40px;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      background: linear-gradient(
        360deg,
        ${({ theme }) => theme.colors.brand[100]} 0%,
        transparent 50%,
        transparent 100%
      );
    }
  }
`;

export const TryTrialBlockContainer = styled.div`
  @media ${breakpoints.laptop} {
    height: 100%;
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }
`;

export const TryTrialBlockDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${breakpoints.laptop} {
    flex-shrink: 0;
    align-items: start;
    justify-content: start;
  }
`;

export const TryTrialBlockTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: bold;
  text-align: center;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
    text-align: left;
    max-width: 600px;
  }
`;

export const TryTrialBlockButtonWrapper = styled.div`
  display: block;
  width: 100%;
  @media ${breakpoints.laptop} {
    display: none;
  }
`;

export const TryTrialBlockAppsContainer = styled.div`
  display: none;
  @media ${breakpoints.laptop} {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
`;

export const TryTrialBlockAppImageWrapper = styled.a`
  display: block;
  position: relative;
  width: 140px;
  height: 40px;
  transition: 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
`;

export const TryTrialBlockImageWrapper = styled.figure`
  margin: 0;
  position: relative;
  width: 100%;
  height: 250px;

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: linear-gradient(
      360deg,
      ${({ theme }) => theme.colors.white} 0%,
      transparent 50%,
      transparent 100%
    );
  }
  @media ${breakpoints.laptop} {
    width: 300px;
    height: 410px;

    &:before {
      display: none;
    }
  }
`;
